import CheckIcon2 from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DeleteIcon } from "../assets/icons/deleteIcon";
import { CheckIcon3 } from "../assets/svg/checkIcon";
import BtnBigWithIcon, { ButtonTyppe } from "./Button/BtnBigWithIcon/BtnBigWithIcon";

export interface IDialogComponent {
    children: any;
    isOpen: boolean;
    titleContent: string;
    onClickConfirm: () => void;
    onClickCancel: (set: boolean) => void;
    isOtpDialog: boolean;
    isCancelButtonNeeded?: boolean;
    isDisableDialog?: boolean;
    isDeleteGroupDialog?: boolean;
}

export const DialogComponent = ({
    children,
    isOpen,
    titleContent,
    onClickCancel,
    onClickConfirm,
    isOtpDialog,
    isCancelButtonNeeded,
    isDisableDialog,
    isDeleteGroupDialog
}: IDialogComponent) => {

    const { t } = useTranslation();

    return (
        <Dialog
        open={isOpen}
        sx={{
            '& .MuiPaper-root': {
                borderRadius: '20px',
                width: '600px',
                paddingY: '10px',
            } 
        }}
        >
        <Box>
            <Box sx={{ width: "100%", display: "flex", alignItems: 'center', justifyContent: "center", marginTop: '10px', textAlign: "center" }}>  
            {isOtpDialog ? 
                <Box sx={{ width: "44px", height: "44px" }}>
                    <DeleteIcon color='#22638D' />
                </Box>
                : isDisableDialog && !isDeleteGroupDialog  ? 
                    <PersonOffIcon sx={{ color: '#22638D', width: '44px', height: '44px'}}/> 
                : isDeleteGroupDialog ?
                <Box sx={{ width: "44px", height: "44px" }}>
                    <DeleteIcon color='#22638D' />
                </Box>
                : <CheckIcon3 />
            }
            </Box>
        <DialogTitle id="alert-dialog-title">
            <Typography
                component='p'
                sx={{
                    textAlign: "center",
                    font: "normal normal 600 20px/28px Segoe UI",
                    letterSpacing: "0px",
                    color: "#2D2D2D",
                    opacity: 1,
                }}
            >
                {titleContent}
            </Typography>
        </DialogTitle>
        <DialogContent                 
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems:'center',
                justifyContent: "center",
            }}
        >
            { children }
        </DialogContent>
        <DialogActions>
        {isDisableDialog ?
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', width: '100%', gap: 1, marginX: '10px' }}>
                <BtnBigWithIcon
                    text={t("Cancelar.message")}
                    onClick={() => onClickCancel(isOtpDialog)}
                    isPrimary={ButtonTyppe.secondary}
                    iconBtnJSX={<CloseIcon/>}
                />
                <BtnBigWithIcon
                    text={t("Confirmar.message")}
                    onClick={() => onClickConfirm()}
                    iconBtnJSX={<CheckIcon2 />}

                />
            </Box>
        :
        <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-around', width: '100%', gap: 1, marginX: '10px'}}>
        <BtnBigWithIcon
        text={t("Confirmar.message")}
        onClick={() => onClickConfirm()}
        />
        { isCancelButtonNeeded ? (
            <BtnBigWithIcon
            text={t("Cancelar.message")}
            onClick={() => onClickCancel(isOtpDialog)}
            isPrimary={ButtonTyppe.secondary}
            />
        ) : (
            <></>
        ) }
        </Box>
        }
        </DialogActions>
            </Box>
    </Dialog>
    )
}